/**
 * Set up routing for all CourseCertificate views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import courseCertificate views
import CreateCourseCertificate from './views/CreateCourseCertificate.js.jsx';
import CourseCertificateList from './views/CourseCertificateList.js.jsx';
import SingleCourseCertificate from './views/SingleCourseCertificate.js.jsx';
import UpdateCourseCertificate from './views/UpdateCourseCertificate.js.jsx';

class CourseCertificateRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <YTRoute exact login={true} path="/my-certificates/courses" component={CourseCertificateList} />
        <YTRoute exact login={true} path="/my-certificates/courses/:courseCertificateId" component={SingleCourseCertificate}/>
      </Switch>
    )
  }
}

export default CourseCertificateRouter;



// WEBPACK FOOTER //
// modules/courseCertificate/CourseCertificateRouter.js.jsx